module.exports = __webpack_public_path__ + "img/pause.e740bc4c.png";